import { render, staticRenderFns } from "./mailTemplateModal.vue?vue&type=template&id=794eb1a6&scoped=true&"
import script from "./mailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./mailTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794eb1a6",
  null
  
)

export default component.exports